export default {
  "platform":"Rainfall Statistics Platform",
  "userName": "Please fill in the email",
  "password": "Please fill in the password",
  "login": "Login",
  "logout": "Logout",
  "userError":"Email cannot be empty",
  "passwordError": "Password cannot be empty",
  "loginError":"The user name or password is incorrect, Please login again",
  "deviceError":"The current device does not have rainfall",
  "deviceDisconnect":"The current equipment rainfall has been disconnected",
  "deviceCount":"Device Count",
  "totalDevice": "Total Device",
  "offDevice": "Off-Line Device",
  "onDevice": "On-Line Device",
  "realTime":"Real Time Rainfall",
  "minuteRainfall":"Real Time Rainfall",
  "instantRainfall":"Instant Rainfall",
  "oneMinute":"One Minute",
  "fiveMinute":"Five Minute",
  "tenMinute":"Ten Minute",
  "hourRainfall":"Hour Rainfall",
  "currentPeriod":"Current Period",
  "previousPeriod":"Previous Period",
  "deviceMap": "Device Map",
  "dayRainfall": "Day Rainfall",
  "dataUpdate":"Data Update",
  "close":"Close",
  "cumulativeRainfall":"Daily Cumulative Rainfall",
  "dailyRainfall":"Daily Rainfall",
  "boundary":"Enter The Day Boundary Time",
  "cordon":"Enter The Rainfall Warning Value",
  "submit":"Submit",
  "rainstorm":"Rainstorm",
  "heavyRain":"Heavy Rain",
  "moderateRain":"Moderate Rain",
  "lightRain":"Light Rain",
  "noRain":"No Rain",
  "boundaryWarn":"The value is between 0 and 23, please re-enter",
  "boundarySuccess":"Successfully set the rainfall boundary value",
  "boundaryError":"Failed to set the rainfall boundary value. Please upload again",
  "cordonWarn":"Please enter the correct numerical value",
  "cordonSuccess":"Rain warning value set successfully",
  "cordonError":"Rainfall limit value setting failed, please upload again",
  "statistical":"Statistical Rainfall",
  "five":"5 minutes",
  "ten":"10 minutes",
  "hour":"1 hour",
  "day":"Day",
  "month":"Month",
  "sum":"Sum",
  "export":"Export",
  "fiveMinuteRainfall":"Five Minute Rainfall",
  "tenMinuteRainfall":"Ten Minute Rainfall",
  "oneHourRainfall":"One Hour Rainfall",
  "dayRain":"Daily Rainfall",
  "monthRain":"Monthly Rainfall",
  "time":"Time",
  "value":"value",
  "noData":"No eligible data",
  "dataList":"Data List",
  "mobileReal":"Real Time Rainfall",
  "mobileStatistical":"Statistical Rainfall",
  "mobileRealTime":"Real",
  "mobileStatisticalRain":"Statistical",
  "mobileDeviceError":"The current device does not have rainfall",
  "mobileInstantRainfall":"Instant Rainfall",
  "mobileOneMinute":"One Minute",
  "mobileFiveMinute":"Five Minute",
  "mobileFenMinute":"Ten Minute",
  "mobileCurrentPeriod":"Current Period",
  "mobilePreviousPeriod":"Previous Period",
  "mobileDailyRainfall":"Daily",
  "mobileDeviceDisconnect":"The current equipment rainfall has been disconnected",
  "mobileDaily":"Daily time",
  "mobileLine":"Rainfall Cordon",
  "mobileSubmit":"Submit",
  "mobileRainstorm":"Rainstorm",
  "mobileHeavyRain":"Heavy",
  "mobileModerateRain":"Moderate",
  "mobileLightRain":"Light",
  "mobileNoRain":"No Rain",
  "mobileBoundaryWarn":"The value is between 0 and 23, please re-enter",
  "mobileBoundarySuccess":"Successfully set the rainfall boundary value",
  "mobileBoundaryError":"Failed to set the rainfall boundary value. Please upload again",
  "mobileCordonWarn":"Please enter the correct numerical value",
  "mobileCordonSuccess":"Rain warning value set successfully",
  "mobileCordonError":"Rainfall limit value setting failed, please upload again",
  "mobileTimePeriod":"Please select a time period",
  "mobileExport":"Export",
  "mobileFive":"Five",
  "mobileTen":"Ten",
  "mobileHour":"Hour",
  "mobileDay":"Day",
  "mobileMonth":"Month",
  "mobileSum":"Sum",
  "mobileFiveMinuteRainfall":"Five Minute Rainfall",
  "mobileTenMinuteRainfall":"Ten Minute Rainfall",
  "mobileOneHourRainfall":"One Hour Rainfall",
  "mobileDayRain":"Daily Rainfall",
  "mobileMonthRain":"Monthly Rainfall",
  "mobileLoad":"Loading",
  "mobileValue":"value",
  "mobileNoData":"No eligible data",
}



// WEBPACK FOOTER //
// ./src/lang/en.js